import { EventContext } from "../types";

export function dataTrackingLog(data: EventContext, color: string) {
  console.log(
    `%c[DT] EVENTO DISPARADO:%c `,
    `background: ${color}; color: white; font-weight: bold; padding: 2px 4px; border-radius: 3px;`,
    'color: #fff;',
    data || ''
  );
}

export function setCookie(name: string, value: string, days = 7) {
  const encodedValue = encodeURIComponent(value);

  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = `${name}=${encodedValue}${expires}; path=/;`;
}

export const paymentTypeMap = [
  ['vale', 'vale crédito'],
  ['pagaleve', 'pix'],
  ['pix parcel', 'pix parcelado'],
  ['pix', 'pix'],
  ['apple', 'apple pay'],
  ['google', 'google pay'],
  ['boleto', 'boleto'],
  ['paypal', 'paypal'],
  ['cred', 'cartão'],
  ['visa', 'cartão'],
  ['master', 'cartão'],
  ['amex', 'cartão'],
  ['elo', 'cartão'],
  ['hiper', 'cartão'],
  ['diner', 'cartão'],
  ['deb', 'cartão'],
];


export const toNum = (val: unknown) => typeof val === 'string' ? Number(val.replace(/[^\d,]/g, '').replace(',', '.')) : val

export const documentToHash = async (document: string | undefined): Promise<string | null> => {
  if (!document) return null

  const encoder = new TextEncoder();
  const data = encoder.encode(document);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}